import React, { useContext, useEffect, useState, useRef, useMemo, useCallback } from 'react';
import { DatabaseContext } from '../../../redux/DatabaseStore';
import { useFormik } from 'formik';
import { getRequest, postRequest, deleteRequest, tabulatorGet, fetchTextGet, downloadBlobGet } from '../../../api/ApiController';
import { PrintIcon, ExportIcon, RefreshIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, PaperClipIcon, EditIcon, DeleteIcon, CollapseTreeIcon, ExpandTreeIcon, BranchTreeIcon} from "../../svg/svgIcons";
import { Dialog } from 'primereact/dialog';
import AuthContext from '../../../components/AuthContext';
import UtilContext from '../../../components/UtilContext';
import { LocaleContext } from '../../../components/LocaleContext';
import { Splitter, SplitterPanel } from 'primereact/splitter';
import { ReactTabulator,reactFormatter } from 'react-tabulator';
import { OverflowMenuProvider } from '../../../components/toolbar/OverflowMenu';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { PanelMenu } from 'primereact/panelmenu';
import { Checkbox } from 'primereact/checkbox';
import IntersectionObserverWrapper from '../../../components/toolbar/IntersectionObserverWrap';
import ReactDOMServer from 'react-dom/server';
import { createArrayNavigateHandlers } from '../../../utils/arrayNavigate';
import { getModuleSettingValue } from '../../../utils/moduleSettings';
import { getDateFormat } from '../../../utils/dateUtils';
import { asRowList, formatTreeValidityLabel, protocolFileList } from '../../../utils/otkCompanyCertTabulatorCells';
import { resetTabulatorMask } from '../../../utils/tabulatorResetMask';
import { createDedupedAjaxRequest, refreshProgressiveFromStart } from '../../../utils/tabulatorProgressiveLoading';
import { getPusherChannel } from '../../../utils/pusherChannel';
import { inputOnEnterHeaderFilter } from '../../../utils/inputOnEnterHeaderFilter';
import { buildTabulatorIdColumn } from '../../../utils/tabulatorIdColumn';
import { TABULATOR_AUDIT_MIN_ROW_HEIGHT, TABULATOR_AUDIT_PROFILES, buildAuditTabulatorColumns } from '../../../utils/tabulatorAuditColumns';
import { buildExportQueryStringFromParams, openPrintHtmlWindow, triggerBlobDownload } from '../../../utils/serviceTaskExport';
import { xlsxDownloadFilename } from '../../../utils/exportExcelNaming';
import { emitOtkCompanyCertStateMutation, OTK_COMPANY_CERT_KIND, resolveOtkCertTreeAuditRow, otkCertTreeRowKey } from '../../../utils/otkCompanyCertStateListSync';
import {
  QLTY029_MASK_PAGE,
  QLTY029_DEFAULT_COLUMNS_VISIBLE,
  QLTY029_MASK_DIALOG_FIELDS,
  QLTY029_PAGED_URL,
  QLTY029_PRINT_URL,
  QLTY029_XLSX_URL,
  QLTY029_SHOW_URL,
  buildQlty029RequestParams,
  decorateQlty029PagedRows,
  buildQlty029MutationDetail,
  isQlty029SessionInvalidatingKind,
  shouldQlty029ApplySafeParentUpdate,
} from '../../../utils/otkCompanyCertRecordDetailSession';


export default function OtkCompanyCertRecordDetail({otk_company, type}) {

    const [state,dispatch] = useContext(DatabaseContext);
    const {setDialogText,setVisible,openFavoriteDialog,toast,setFastView,setUserMaskFilter,openFilePreview, openChosenNotificationPreferences,getUserColor,getUserInitials} = useContext(UtilContext);
    const { t } = useContext(LocaleContext);
    const {user} = useContext(AuthContext);
    const dateFmt = getDateFormat(state?.module_settings || []);
    const dateTimeFmt = `${dateFmt} HH:mm`;

    const [closeTab,setCloseTab] = useState(false);
    const ref = useRef(null);
    const submitRef = useRef(null);
    const overlayRef = useRef(null);

    const [formOtkCompany,setformOtkCompany] = useState(otk_company);
    const [formType, setFormType] = useState(type);

    const [markUnmark, setMarkUnmarked] = useState(true);
    const [selectedRecord,setSelectedRecord] = useState(null);

    const [columnsVisible, setColumnsVisible] = useState(() => ({ ...QLTY029_DEFAULT_COLUMNS_VISIBLE }));
    const [maskVisible, setMaskVisible] = useState(false);
//TODO dorobit contractor id
    const [scrollIcons,setScrollIcons] = useState((user.permissions?.includes("edit otk-company"))?false:true);
    const [editIcon,setEditIcon] = useState(true);
    const [deleteIcon,setDeleteIcon] = useState(true);
    
    const [visibleRecord,setVisibleRecord] = useState(false);
    const [images,setImages] = useState('');
    const [updatefileList, setUpdateFileList] = useState([]);
    const updateFileListRef = useRef(null);
    const [company,setCompany] = useState("");
    const [certificates,setCertificates] = useState([]);
    const [otkCertificates, setOtkCertificates] = useState([]);
    const [navigationList, setNavigationList] = useState([]);
    const inFlightRef = useRef({ sig: null, promise: null });
    const completedCacheRef = useRef(new Map());
    const savedHScrollRef = useRef({ left: 0, pending: false });
    const tableContainerRef = useRef(null);
    const tableBuiltRef = useRef(false);
    const currentCompanyIdRef = useRef(otk_company?.id ?? null);
    const getTable = useCallback(() => ref.current?.table ?? ref.current, []);

    const pageSizePc = useMemo(() => {
        const v = (state.module_settings || []).find(s => s.module === 'global' && s.key === 'page_size_pc')?.value;
        const n = parseInt(v, 10);
        return (Number.isFinite(n) && n > 0) ? n : 50;
    }, [state.module_settings]);

    const buildRequestParams = useCallback((paramsFromTabulator = {}) => {
        return buildQlty029RequestParams({
            paramsFromTabulator,
            pageSize: pageSizePc,
            companyId: currentCompanyIdRef.current ?? formOtkCompany?.id ?? otk_company?.id,
            getTable,
        });
    }, [pageSizePc, formOtkCompany?.id, otk_company?.id, getTable]);

    const fetchPaged = useCallback((url, merged) => {
        return tabulatorGet(url, merged).then((r) => {
            const data = decorateQlty029PagedRows(r?.data ?? []);
            return { data, last_page: r?.last_page ?? 1, total: r?.total ?? 0 };
        });
    }, []);

    const ajaxRequestFunc = useMemo(
        () => createDedupedAjaxRequest(buildRequestParams, fetchPaged, inFlightRef, completedCacheRef),
        [buildRequestParams, fetchPaged]
    );

    const getPrintColumnsOrder = useCallback(() => {
        const table = getTable();
        const allowed = Object.keys(QLTY029_DEFAULT_COLUMNS_VISIBLE).filter((f) => f !== 'id');
        const fallback = () => allowed.filter((f) => columnsVisible[f] !== false);
        if (!table?.getColumns) return fallback();
        const allowedSet = new Set(allowed);
        const out = [];
        const seen = new Set();
        try {
            table.getColumns().forEach((col) => {
                const field = col.getField?.() ?? col.getDefinition?.()?.field;
                if (!field || !allowedSet.has(field)) return;
                if (columnsVisible[field] === false) return;
                if (seen.has(field)) return;
                seen.add(field);
                out.push(field);
            });
        } catch (_e) {
            return fallback();
        }
        return out.length > 0 ? out : fallback();
    }, [getTable, columnsVisible]);

    const buildCompanyCertExportQueryString = useCallback((opts = {}) => {
        const extra = buildRequestParams({});
        return buildExportQueryStringFromParams(extra, opts);
    }, [buildRequestParams]);

    const runCompanyCertPrint = useCallback(async () => {
        try {
            setDialogText?.(t('Common.PreparingPrint'));
            setVisible?.(true);
            const suffix = buildCompanyCertExportQueryString({
                includePrintColumns: true,
                printColumns: getPrintColumnsOrder(),
            });
            const html = await fetchTextGet(`${QLTY029_PRINT_URL}${suffix}`);
            if (!openPrintHtmlWindow(html)) {
                toast?.current?.show({ severity: 'warn', summary: t('Common.Print'), detail: t('Common.EnablePopups'), life: 4000 });
            }
        } catch (e) {
            toast?.current?.show({ severity: 'error', summary: t('Common.Print'), detail: e?.message || t('BusinessPartnerList.Toast.PrintFailed'), life: 4500 });
        } finally {
            setVisible?.(false);
        }
    }, [buildCompanyCertExportQueryString, getPrintColumnsOrder, setDialogText, setVisible, t, toast]);

    const exportCompanyCertXlsx = useCallback(async () => {
        try {
            setDialogText?.('Pripravujem export...');
            setVisible?.(true);
            const suffix = buildCompanyCertExportQueryString({
                includePrintColumns: true,
                printColumns: getPrintColumnsOrder(),
            });
            const { blob, filename } = await downloadBlobGet(`${QLTY029_XLSX_URL}${suffix}`, xlsxDownloadFilename('company-certificates'));
            triggerBlobDownload(blob, filename || xlsxDownloadFilename('company-certificates'));
        } catch (e) {
            toast?.current?.show({ severity: 'error', summary: t('Common.Export'), detail: e?.message || t('Common.ExportFailed'), life: 4500 });
        } finally {
            setVisible?.(false);
        }
    }, [buildCompanyCertExportQueryString, getPrintColumnsOrder, setDialogText, setVisible, toast]);


    const captureHScroll = useCallback(() => {
        const table = getTable();
        if (!table?.rowManager?.element) return;
        savedHScrollRef.current = { left: table.rowManager.element.scrollLeft, pending: true };
    }, [getTable]);
    const restoreHScroll = useCallback(() => {
        if (!savedHScrollRef.current.pending) return;
        const table = getTable();
        if (!table?.rowManager?.element) return;
        const holder = table.rowManager.element;
        const header = table.columnManager?.contentsElement;
        const left = savedHScrollRef.current.left;
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                holder.scrollLeft = left;
                if (header) header.scrollLeft = left;
                savedHScrollRef.current.pending = false;
            });
        });
    }, [getTable]);
    const refreshFromStart = useCallback(() => refreshProgressiveFromStart(getTable, completedCacheRef, t('Common.LoadingEllipsis')), [getTable]);

    const currentCompanyId = formOtkCompany?.id ?? null;
    useEffect(() => {
      currentCompanyIdRef.current = currentCompanyId;
    }, [currentCompanyId]);

    useEffect(() => {
      const channel = getPusherChannel();
      if (!channel) return;
      const DEDUPE_MS = 800;
      const lastHandled = { key: '', at: 0 };
      const shouldSkip = (eventType, id) => {
        if (id == null) return true;
        const key = `${eventType}-${id}`;
        const now = Date.now();
        if (lastHandled.key === key && now - lastHandled.at < DEDUPE_MS) return true;
        lastHandled.key = key;
        lastHandled.at = now;
        return false;
      };
      const listType = 'otk';
      const isMyType = (p) => p?.type === listType;
      const getLoadedParentRow = (id) => {
        const t = getTable();
        if (!t?.getRow || id == null) return null;
        try {
          const byKey = t.getRow(otkCertTreeRowKey({ id }, false));
          if (byKey && byKey !== false) return byKey;
        } catch (_e) { /* fall through */ }
        try {
          const byId = t.getRow(id);
          return byId && byId !== false ? byId : null;
        } catch (_err) {
          return null;
        }
      };
      const invalidate = () => {
        refreshProgressiveFromStart(getTable, completedCacheRef, t('Common.LoadingEllipsis'));
      };
      const applyCanonicalOrInvalidate = (row, kind) => {
        if (!row?.id) { invalidate(); return; }
        if (row.company_id != null && Number(row.company_id) !== Number(currentCompanyIdRef.current)) {
          const rc = getLoadedParentRow(row.id);
          if (rc) rc.delete();
          return;
        }
        const data = decorateQlty029PagedRows([row])[0];
        const rc = getLoadedParentRow(row.id);
        if (shouldQlty029ApplySafeParentUpdate(kind, Boolean(rc))) {
          rc.update(data).catch(() => invalidate());
          return;
        }
        invalidate();
      };
      const onCreated = (payload) => {
        if (!isMyType(payload)) return;
        const id = payload?.id;
        if (id == null || shouldSkip('company_certificate.created', id)) return;
        if (isQlty029SessionInvalidatingKind(OTK_COMPANY_CERT_KIND.PARENT_CREATED)) invalidate();
      };
      const onUpdated = (payload) => {
        if (!isMyType(payload)) return;
        const id = payload?.id;
        if (id == null || shouldSkip('company_certificate.updated', id)) return;
        getRequest(QLTY029_SHOW_URL(id)).then((res) => {
          const row = res?.data?.data ?? res?.data ?? res;
          applyCanonicalOrInvalidate(row, OTK_COMPANY_CERT_KIND.PARENT_UPDATED);
        }).catch(() => invalidate());
      };
      const onDeleted = (payload) => {
        if (!isMyType(payload)) return;
        const id = payload?.id;
        if (id == null || shouldSkip('company_certificate.deleted', id)) return;
        const row = getLoadedParentRow(id);
        if (row) row.delete();
        invalidate();
      };
      const refetch = () => invalidate();
      channel.bind('company_certificate.created', onCreated);
      channel.bind('company_certificate.updated', onUpdated);
      channel.bind('company_certificate.deleted', onDeleted);
      channel.bind('company_certificate.activated', refetch);
      channel.bind('company_certificate.deactivated', refetch);
      return () => {
        channel.unbind('company_certificate.created', onCreated);
        channel.unbind('company_certificate.updated', onUpdated);
        channel.unbind('company_certificate.deleted', onDeleted);
        channel.unbind('company_certificate.activated', refetch);
        channel.unbind('company_certificate.deactivated', refetch);
      };
    }, [getTable]);

    const loadNavigationList = useCallback(() => {
        if (otk_company?.id == null) return;
        const params = new URLSearchParams();
        params.set('page', '1');
        params.set('size', String(pageSizePc));
        params.set('type', 'otk');
        params.set('company_id', String(otk_company.id));
        params.set('sorters', JSON.stringify([{ field: 'id', dir: 'asc' }]));
        getRequest('/api/company_certificates/paged?' + params.toString())
            .then(res => {
                const data = res?.data ?? [];
                const withStatus = (Array.isArray(data) ? data : []).map(c => ({
                    ...c,
                    doc_status: c.deactivation_date ? t('Status.DeactivatedFemale') : 'Aktívna',
                }));
                setNavigationList(withStatus);
            })
            .catch(() => setNavigationList([]));
    }, [otk_company?.id, pageSizePc]);
    useEffect(() => { loadNavigationList(); }, [loadNavigationList]);

    useEffect(() => {
        getRequest('/api/company_certificates/paged?type=otk&size=500&page=1')
            .then((r) => setOtkCertificates(r?.data ?? []))
            .catch(() => setOtkCertificates([]));
    }, []);

    const module_settings = state.module_settings || [];
    const showExcludedPartnersByCompany = getModuleSettingValue(module_settings, 'otk', 'show_excluded_partners_list_by_company', '0');
    const isExcludedPartner = (otk_company?.validity != 1 && otk_company?.validity !== '1');
    const hideDetailBySetting = (showExcludedPartnersByCompany !== '1' && isExcludedPartner);

    const handleUpdateFileChange = (event) => {
        setUpdateFileList(event.target.files);
    };

    const validate = values => {
        const errors = {};
        return errors;
    };

    const formikUpdate = useFormik({
        initialValues: selectedRecord==null?{
            start_of_validity: '',end_of_validity: '',description:'',certificate_id:''}
            :{
              id:selectedRecord?.id,
              start_of_validity:selectedRecord?.start_of_validity,end_of_validity:selectedRecord?.end_of_validity,
              description:selectedRecord?.description,certificate_id:selectedRecord?.certificate_id
            },
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            let formData = new FormData();
            for (let value in values) {
                formData.append(value, values[value] != null ? values[value] : "");
            }
            /*for (var pair of formData.entries()) {
                console.log(pair[0]+ ', ' + pair[1]); 
            }*/
            for(let i = 0;i<updatefileList.length;i++){
              //console.log("IMAGE :"+fileList[i].name);
              formData.append('files[]',updatefileList[i]);
            }
            setDialogText(t('Common.Saving'));
            setVisible(true);
            postRequest(`/api/company_cert_records/update/${formikUpdate.values.id}`, formData,true)
            .then((response) => {
                setVisible(false);
                console.log(response);
                const changedFields = [];
                if (String(values.description ?? '') !== String(selectedRecord?.description ?? '')) changedFields.push('description');
                if (String(values.start_of_validity ?? '') !== String(selectedRecord?.start_of_validity ?? '')) {
                    changedFields.push('start_of_validity', 'custom_start_of_validity');
                }
                if (String(values.end_of_validity ?? '') !== String(selectedRecord?.end_of_validity ?? '')) {
                    changedFields.push('end_of_validity', 'custom_end_of_validity');
                }
                if (updatefileList.length) changedFields.push('protocol');
                emitOtkCompanyCertStateMutation(buildQlty029MutationDetail({
                    kind: OTK_COMPANY_CERT_KIND.RECORD_UPDATED,
                    companyId: currentCompanyIdRef.current ?? formOtkCompany?.id ?? otk_company?.id,
                    certificateId: values.certificate_id ?? selectedRecord?.certificate_id,
                    recordId: values.id ?? selectedRecord?.id,
                    changedFields,
                }));
                captureHScroll();
                refreshFromStart();
                loadNavigationList();
                getRequest("/api/companies").then((response) => {
                    dispatch({type:'load_companies',newCompanies:response.data});
                    setVisibleRecord(false);
                    formikUpdate.resetForm();
                    if(updatefileList.length){
                        setUpdateFileList([]);
                        updateFileListRef.current.value = null;
                    }
                    toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                });
                getRequest('/api/company_certificates/paged?type=otk&size=500&page=1').then((r) => setOtkCertificates(r?.data ?? []));
            }).catch((reason) => {
                setVisible(false);
                if(!navigator.online){
                    alert(t('SummaryEmailOTKAdd.Error.Offline'));
                }
                else{
                    alert(t('Common.Toast.ActionFailedDetail'));
                }
            })
        },
    });

    function hideCertRecord(){
      formikUpdate.resetForm();
      setVisibleRecord(false);
    }


    const { scrollToFirst, scrollUp, scrollDown, scrollToLast } = useMemo(
        () => createArrayNavigateHandlers(navigationList, formOtkCompany?.id, setformOtkCompany),
        [navigationList, formOtkCompany?.id]
    );

    const onSelectRow =  (data, rows) => {
      setDeleteIcon(true);
      setEditIcon(true);
      formikUpdate.resetForm();
      if(data.length>0){
          let children = 0;
          let parent = 0;
          data.forEach(obj => {
              if(obj?.certificate_id>0){
                  children++;
              }
              else parent++;
          });
          if(children>0 && parent==0){
            console.log(user.permissions);
              if(user.permissions?.includes("delete otk-company"))setDeleteIcon(false);
              if(data?.length==1 && user.permissions?.includes("edit otk-company")){
                  setSelectedRecord(data[0]);
                  formikUpdate.setValues(data[0]);
                  setEditIcon(false);
              }
          }
      }
    }

    function getRecordFiles(id){
        getRequest(`/api/company_cert_records/protocols/${id}`).then((response) => {
            console.log(response);
            if(response.data!=="{}")setImages(response.data);
        });
    }
    
    const acceptFile = (id) => {
        getRequest(`/api/company_cert_records/deleteProtocol/${id}`)
        .then((response) => {
            toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('DocumentationAdd.Toast.FileDeleted') });
            emitOtkCompanyCertStateMutation(buildQlty029MutationDetail({
                kind: OTK_COMPANY_CERT_KIND.RECORD_FILE_CHANGED,
                companyId: currentCompanyIdRef.current ?? formOtkCompany?.id ?? otk_company?.id,
                certificateId: selectedRecord?.certificate_id,
                recordId: selectedRecord?.id ?? id,
                changedFields: ['protocol'],
            }));
            getRecordFiles(selectedRecord?.id);
            // File mutation changes nested protocol display → restart progressive session
            captureHScroll();
            refreshFromStart();
        }).catch((reason) => {
            alert(reason);
            toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('DocumentationAdd.Toast.FileDeleteFailed'), life: 3000 });
        })
    };
    

    function deleteFiles(img){
      confirmDialog({
          message: t('DocumentationAdd.Confirm.DeleteFileMessage'),
          header: t('ServiceTask.ConfirmDeleteTitle'),
          icon: 'pi pi-info-circle',
          acceptClassName: 'p-button-danger',
          acceptLabel: t('Common.No'),
          rejectLabel: t('Common.Yes'),
          accept:reject,
          reject:() => acceptFile(img.id)
      });
    }

    function NameFormatter(props) {
      const rowData = props.cell.getRow().getData();
      var parent = props.cell.getRow()?.getTreeParent();
      if(rowData?._children) return <div className='training_name'>{rowData.name}</div>;
      if(parent){
          let parent_array = asRowList(parent._row?.data?._children);
          for(let i = 0;i<parent_array.length;i++){
              if(parent_array[i].id == rowData.id){
                  if(i==parent_array.length-1)return <div className='training_name'>Prvotný certifikát</div>;
                  else return <div className='training_name'>{parent_array.length-1-i}. Opakovaný certifikát</div>;
              }
          }
          return <div className='training_name'>{parent._row.data.name}</div>;
      }
      return "";
  }  

    function viewFile(file_id){
        getRequest(`/api/company_cert_records/protocol/${file_id}`).then((response) => {
            if (response?.data?.url) openFilePreview({ url: response.data.url, filename: response.data.filename });
        });
    }

      function Protocol(props) {
        const rowData = props.cell.getRow().getData();
        const files = protocolFileList(rowData);
        if (!files.length) return "";
        return <div className='flex flex-row'>{files.map((img) => (<a style={{color:'blue',cursor:'pointer',marginBottom:'2px',width: '24px',display: 'block'}} onClick={() => {viewFile(img.id);}}><PaperClipIcon/></a>))}</div>;
    }

    function EndOfValidity(props){
        const rowData = props.cell.getRow().getData();
        const label = formatTreeValidityLabel(rowData, 'end_of_validity', dateFmt);
        if (label) return label;
        return <span className='text-red-500'>{t('Ui.R67.Nevykonane')}</span>;
    }

    function StartOfValidity(props){
        const rowData = props.cell.getRow().getData();
        const label = formatTreeValidityLabel(rowData, 'start_of_validity', dateFmt);
        if (label) return label;
        return <span className='text-red-500'>{t('Ui.R67.Nevykonane')}</span>;
    }

    function StateFormatter(props){
      const rowData = props.cell.getRow().getData();
      var parent = props.cell.getRow()?.getTreeParent();
      if(parent){
          let parent_array = asRowList(parent._row?.data?._children);
          for(let i = 0;i<parent_array.length;i++){
              if(parent_array[i].id == rowData.id){
                  if(i==parent_array.length-1){
                      if(new Date(parent_array[i]?.end_of_validity) < new Date()){
                          return "NOK";
                      }
                      else return "OK";
                  }
                  else return "OK";
              }
          }
      }
      if(asRowList(rowData?._children).length > 0){
          if(new Date(rowData?._children[0]?.end_of_validity) < new Date()){
              return "NOK";
          }
          return "OK"
      }
      else return "NOK";
    }

    function CertDescriptionFormatter(props){
        const rowData = props.cell.getRow().getData();
        return rowData?.cert_description ?? rowData?.description;
      }

    function DocStatusFormatter(props){
        const row = props.cell.getRow();
        const data = row.getData();
        let deact = data?.deactivation_date;
        const parent = row.getTreeParent?.();
        if ((deact === undefined || deact === null || deact === '') && parent) deact = parent.getData()?.deactivation_date;
        return <span>{deact ? t('Status.DeactivatedFemale') : 'Aktívna'}</span>;
      }

    const remoteHeaderFilter = useCallback(() => true, []);
    const enterInput = { headerFilter: inputOnEnterHeaderFilter, headerFilterLiveFilter: false, headerFilterFunc: remoteHeaderFilter };

    const auditTailColumns = useMemo(
      () =>
        buildAuditTabulatorColumns({
          profile: TABULATOR_AUDIT_PROFILES.createdByUpdatedBy,
          includeId: false,
          dateFormat: dateFmt,
          dateTimeFormat: dateTimeFmt,
          getUserColor,
          getUserInitials,
          textHeaderFilter: inputOnEnterHeaderFilter,
          remotePassthrough: true,
          auditSourceFn: resolveOtkCertTreeAuditRow,
        }).map((col) =>
          col.field === 'created_at'
            ? { ...col, title: t('Common.Column.CreatedAt') }
            : col.field === 'updated_at'
              ? { ...col, title: t('Common.Column.UpdatedAt') }
              : col
        ),
      [dateFmt, dateTimeFmt, getUserColor, getUserInitials]
    );

    const columns = useMemo(() => [
      {
        formatter: 'rowSelection',
        titleFormatter: 'rowSelection',
        titleFormatterParams: { rowRange: 'active' },
        hozAlign: 'center',
        width: 44,
        headerSort: false,
        resizable: false,
        frozen: true,
        print: false,
        download: false,
        cellClick: function (e, cell) {
          cell.getRow().toggleSelect();
        },
      },
      buildTabulatorIdColumn({
        frozen: true,
        extra: {
          ...enterInput,
          title: 'ID',
        },
      }),
      { title: t('Common.Name'), field: 'name', formatter: reactFormatter(<NameFormatter/>), ...enterInput, minWidth: 200, widthGrow: 1 },
      { title: t('Otk.Column.DocStatus'), field: 'doc_status', headerFilter: 'list', headerFilterLiveFilter: false, headerFilterParams: { values: { Aktívna: 'Aktívna', Deaktivovaná: t('Status.DeactivatedFemale') }, clearable: true }, headerFilterFunc: remoteHeaderFilter, minWidth: 260, widthGrow: 0.5, formatter: reactFormatter(<DocStatusFormatter/>) },
      { title: t('Common.Description'), field: 'description', ...enterInput, minWidth: 200, widthGrow: 1 },
      { title: t('Common.ValidFrom'), field: 'custom_start_of_validity', ...enterInput, minWidth: 200, widthGrow: 1, formatter: reactFormatter(<StartOfValidity/>) },
      { title: t('Common.ValidTo'), field: 'custom_end_of_validity', ...enterInput, minWidth: 200, widthGrow: 1, formatter: reactFormatter(<EndOfValidity/>) },
      { title: t('Calibration.CertificateDescription'), field: 'cert_description', formatter: reactFormatter(<CertDescriptionFormatter/>), ...enterInput, minWidth: 200, widthGrow: 1 },
      { title: t('Common.Status'), field: 'state', formatter: reactFormatter(<StateFormatter/>), ...enterInput, minWidth: 200, widthGrow: 1 },
      { title: 'Protokol', field: 'protocol', ...enterInput, minWidth: 200, widthGrow: 1, formatter: reactFormatter(<Protocol/>) },
      ...auditTailColumns,
    ], [enterInput, remoteHeaderFilter, auditTailColumns]);


    function setMask(item,value){
        const columnVisible = {...columnsVisible};
       columnVisible[item] = value;
       console.log(columnVisible);
        const t = getTable();
        for(const val in columnVisible) {
          if(columnVisible[val]==false){
            t?.hideColumn?.(val);
          }
          else{
            t?.showColumn?.(val);
          }
        }
        setColumnsVisible(columnVisible);
      }

      const itemRenderer = (item, options) => (
        <a className="flex align-items-center px-3 py-2 cursor-pointer items-center bg-[#333] text-white w-[180px]" onClick={options.onClick}>
            <span className={`${item.icon} text-primary`} />
            <span className={`mx-2 ${item.items && 'font-semibold'}`}>{item.label}</span>
            {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
        </a>
      );
    
      const [expandedKeys, setExpandedKeys] = useState({});
    
      const handleClickOutside = (event) => {
        if (overlayRef.current && !overlayRef.current.contains(event.target)) {
            setExpandedKeys({});
        }
      };
    
      useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);

    const resetMask = () => resetTabulatorMask({
      page: QLTY029_MASK_PAGE,
      defaultColumnsVisible: QLTY029_DEFAULT_COLUMNS_VISIBLE,
      ref, columns, setColumnsVisible,
    });

      const items = [
      {
        key: '0',
        label: t('Common.Actions'),
        icon: 'pi pi-sliders-v',
        template: itemRenderer,
        items: [
            {
                key: '0_1',
                label: t('Common.SetFilter'),
                icon: 'pi pi-filter',
                command: () => {setUserMaskFilter(QLTY029_MASK_PAGE,"set_filters",null,getTable()?.getHeaderFilters?.() ?? [],null);captureHScroll();refreshFromStart();},
                template: itemRenderer,
            },
              {
                key: '0_2',
                label: t('Common.ClearFilter'),
                icon: 'pi pi-filter-slash',
                command: () => {setUserMaskFilter(QLTY029_MASK_PAGE,"set_filters",null,[],null);getTable()?.clearHeaderFilter?.();captureHScroll();refreshFromStart();},
                template: itemRenderer,
            },
            {
                key: '0_3',
                label: t('Common.SetSorting'),
                icon: 'pi pi-sort-alt',
                command: () => {setUserMaskFilter(QLTY029_MASK_PAGE,"set_sorters",null,null,null,getTable()?.getSorters?.() ?? []);OverflowMenuProvider.setVisible(null);setExpandedKeys({});captureHScroll();refreshFromStart();},
                template: itemRenderer,
            },
            {
                key: '0_4',
                label: t('Common.ClearSorting'),
                icon: 'pi pi-sort-alt-slash',
                command: () => {setUserMaskFilter(QLTY029_MASK_PAGE,"set_sorters",null,null,null,[]);getTable()?.setSort?.([]);OverflowMenuProvider.setVisible(null);setExpandedKeys({});captureHScroll();refreshFromStart();},
                template: itemRenderer,
            },
            {
                key: '0_5',
                label: t('Common.SetMask'),
                icon: 'pi pi-server',
                command: () => {setMaskVisible(true);OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
                template: itemRenderer,
            },
            {
                key: '0_5b',
                label: t('Common.ResetUserMask'),
                icon: 'pi pi-refresh',
                command: () => {resetMask();OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
                template: itemRenderer,
            },
            {
              key: '0_6',
              label: t('Common.Notifications'),
              icon: 'pi pi-envelope',
              command: () => {openChosenNotificationPreferences('OtkCompanyCertRecordDetail');OverflowMenuProvider.setVisible(null);},
              template: itemRenderer,
          },
        ]
      }
    ];function changeMarkings(value){
        const t = getTable();
        const columnVisible = {...columnsVisible};
        for(let val in columnVisible) {
          if(columnVisible[val]!=="id" && columnVisible[val]!=="editor" && columnVisible[val]!=="end_of_validity"){
            columnVisible[val]=value;
            if (value) t?.showColumn?.(val);
            else t?.hideColumn?.(val);
          }
        };
        setColumnsVisible(columnVisible);
      }
    
      const reject = () => {
          toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.RequestCancelled'), life: 3000 });
      }

    const acceptCertificate = () => {
        setDialogText(t('Common.DeletingShort'));
        setVisible(true);
        const rows_to_delete = getTable()?.getSelectedData?.() ?? [];
        let completed = 0;
        const total = rows_to_delete.length;
        rows_to_delete.forEach(element => {
          deleteRequest(`/api/company_cert_records/${element.id}`)
              .then((response) => {
                completed++;
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordDeletedDetail') });
                emitOtkCompanyCertStateMutation(buildQlty029MutationDetail({
                    kind: OTK_COMPANY_CERT_KIND.RECORD_DELETED,
                    companyId: currentCompanyIdRef.current ?? formOtkCompany?.id ?? otk_company?.id,
                    certificateId: element.certificate_id,
                    recordId: element.id,
                }));
                captureHScroll();
                refreshFromStart();
                loadNavigationList();
                getRequest('/api/company_certificates/paged?type=otk&size=500&page=1').then((r) => setOtkCertificates(r?.data ?? []));
                if (completed === total) setVisible(false);
              }).catch((reason) => {
                  setVisible(false);
                  alert(reason);
                  toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.DeleteFailedDetail'), life: 3000 });
              })
        });
    }

      const confirm = () => {
        confirmDialog({
            message: t('ServiceTask.ConfirmDeleteRecord'),
            header: t('ServiceTask.ConfirmDeleteTitle'),
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: t('Common.No'),
            rejectLabel: t('Common.Yes'),
            accept: reject,
            reject: acceptCertificate
        });
    };


    if (hideDetailBySetting) {
        return (
            <div className="flex flex-col items-center justify-center p-8 gap-4 max-w-md mx-auto">
                <p className="text-center text-zinc-700">{t('Ui.R67.Tato_polozka_vyradeny_partner_nie_je_v_zozname_Zoznam_platno')}</p>
                <button
                    type="button"
                    onClick={() => dispatch({ type: 'close_tab', id: state.selectedTab })}
                    className="px-4 py-2 bg-zinc-800 text-white rounded hover:bg-zinc-700"
                >
                    Zavrieť
                </button>
            </div>
        );
    }

    return ( 
        <>
            <div>
            <div className='w-full h-10 flex flex-row bg-[#333]'> 
            <IntersectionObserverWrapper>
            <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="edit"><button className="disabled:opacity-25" disabled={editIcon} onClick={() => {getRecordFiles(selectedRecord?.id);setVisibleRecord(true);}}><EditIcon/></button></div>
            <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="delete"><button className="disabled:opacity-25" onClick={confirm} disabled={deleteIcon}><DeleteIcon/></button></div>
            <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="print"><button type="button" onClick={() => runCompanyCertPrint()} title={t('Common.Print')}><PrintIcon/></button></div>
            <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="export"><button type="button" onClick={() => exportCompanyCertXlsx()} title={t('Common.ExportXlsx')}><ExportIcon/></button></div>
            <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="refresh"><button type="button" onClick={() => { captureHScroll(); refreshFromStart(); }} title={t('Common.Refresh')}><RefreshIcon/></button></div>      
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="first"><button className="disabled:opacity-25" onClick={() => scrollToFirst()} disabled={scrollIcons || !navigationList?.length} title={t('Common.First')}><BackToFirstIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="back"><button className="disabled:opacity-25" onClick={() => scrollUp()} disabled={scrollIcons || !navigationList?.length} title={t('Common.Previous')}><BackIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="forward"><button className="disabled:opacity-25" onClick={() => scrollDown()} disabled={scrollIcons || !navigationList?.length} title={t('Common.Next')}><ForwardIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="last"><button className="disabled:opacity-25" onClick={() => scrollToLast()} disabled={scrollIcons || !navigationList?.length} title={t('Common.Last')}><ForwardToLastIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="favorite"><button className="disabled:opacity-25" disabled onClick={() => openFavoriteDialog(t('Otk.EditTrainingCompanyCerts'),QLTY029_MASK_PAGE)}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="price"><button className="disabled:opacity-25" disabled onClick={() => setFastView(QLTY029_MASK_PAGE,columnsVisible,columns)}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className="card flex justify-content-center z-[100]" data-targetid="actions" ref={overlayRef}>
            <PanelMenu model={items} expandedKeys={expandedKeys} onExpandedKeysChange={setExpandedKeys} className="w-full md:w-20rem"/>
          </div>
          </IntersectionObserverWrapper>
        </div>
        <Splitter className='h-[calc(100vh_-_177px)]' layout="vertical" pt={{ gutter: { className: 'bg-[#333] h-8' },gutterHandler: { className: 'bg-secondary ' } }}>
        <SplitterPanel className="flex align-items-center justify-content-center overflow-y-auto " minSize={10} size={63}>
        <div className="w-full relative flex flex-col h-full overflow-x">
          <div className='xl:grid grid-cols-2 gap-1 mb-2 '>
            <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                <h1 className="text-3xl font-semibold text-left text-zinc-900">{t('Ui.R67.DOKUMENTACIE_PARTNERA')}</h1>
                {formType=="edit" && <label className="block text-md font-semibold text-gray-800">Por.č.: {formOtkCompany?.id}</label>}
                      <div>
                        <label
                            htmlFor="name"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.CompanyNameUpper')}</label>
                        <input
                        readOnly={true}
                            name='name'
                            type="text"
                            value={formOtkCompany?.name}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="tel_number"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.PhoneNumber')}</label>
                        <input
                        readOnly={true}
                            name='tel_number'
                            type="text"
                            value={formOtkCompany?.tel_number}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                    
                      <div>
                        <label
                            htmlFor="email"
                            className="block text-md font-semibold text-gray-800"
                        >
                            E-MAIL
                        </label>
                        <input
                        readOnly={true}
                            name='email'
                            type="text"
                            value={formOtkCompany?.email}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="contact_person"
                            className="block text-md font-semibold text-gray-800 mt-2"
                        >{t('Common.ContactPersonUpper')}</label>
                        <input
                        readOnly={true}
                            name='contact_person'
                            type="text"
                            value={formOtkCompany?.contact_person}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>        
            </div>
            <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                    <div>
                        <label
                            htmlFor="address"
                            className="block text-md font-semibold text-gray-800"
                        >
                            ADRESA
                        </label>
                        <input
                        readOnly={true}
                            name='address'
                            type="text"
                            value={formOtkCompany?.address}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="fax"
                            className="block text-md font-semibold text-gray-800"
                        >
                             FAX
                        </label>
                        <input
                        readOnly={true}
                            name='fax'
                            type="text"
                            value={formOtkCompany?.fax}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="web_address"
                            className="block text-md font-semibold text-gray-800"
                        >
                            WEB. ADRESA
                        </label>
                        <input
                        readOnly={true}
                            name='web_address'
                            type="text"
                            value={formOtkCompany?.web_address}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="description"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.NoteUpper')}</label>
                        <textarea
                        readOnly={true}
                            name='gauge_name'
                            type="text"
                            value={formOtkCompany?.description}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        >
                        </textarea>
                        </div>    
            </div> 
            </div>
            </div> 
             </SplitterPanel>
             <SplitterPanel className="flex flex-col align-items-center justify-content-center w-full overflow-y-auto" size={37} style={{minHeight: '110px'}}>
             <div ref={tableContainerRef} className="w-full h-full">
             <ReactTabulator
               data={undefined}
               className='h-[calc(100vh_-_176px)]'
               onRef={(r) => (ref.current = r?.current ?? r)}
               columns={columns}
               events={{
                 rowSelectionChanged: onSelectRow,
                 headerFilterChanged: () => { captureHScroll(); refreshFromStart(); },
                 renderComplete: () => restoreHScroll(),
                 tableBuilt: () => {
                    tableBuiltRef.current = true;
                    let mask = state.user_mask_filters.filter(mask => mask.page==QLTY029_MASK_PAGE);
                    const safeParse = (v, fallback) => {
                        if (v === null || v === undefined) return fallback;
                        if (typeof v === "string") {
                        try { return JSON.parse(v); } catch { return fallback; }
                        }
                        return v;
                    };
                    if (mask.length > 0) {
                        const t = getTable();
                        const attributes  = safeParse(mask[0].attributes, []);
                        const filters     = safeParse(mask[0].filters, []);
                        const sorters     = safeParse(mask[0].sorters, []);
                        const json_columns = safeParse(mask[0].columns, {});
                        if (Array.isArray(attributes) && attributes.length > 1) {
                            t?.setColumnLayout?.(attributes);
                        }
                        if (Array.isArray(filters)) {
                            filters.forEach(f => t?.setHeaderFilterValue?.(f.field, f.value));
                        }
                        if (Array.isArray(sorters) && sorters.length > 0) {
                            t?.setSort?.(sorters);
                        }
                        if (json_columns && typeof json_columns === "object") {
                            setColumnsVisible(json_columns);
                            for (let column in json_columns) {
                                if (json_columns[column] === false) t?.hideColumn?.(column);
                                else t?.showColumn?.(column);
                            }
                        }
                        refreshFromStart();
                    }
                  },
                 columnMoved:() => {
                   setUserMaskFilter(QLTY029_MASK_PAGE,"column_move",null,null,getTable()?.getColumnLayout?.());
                 },
                 columnResized:() => {
                   setUserMaskFilter(QLTY029_MASK_PAGE,"column_move",null,null,getTable()?.getColumnLayout?.());
                 }
               }}
               options={{
                index: '_rowKey',
                layout:"fitColumns",renderHorizontal:"virtual",rowHeight:TABULATOR_AUDIT_MIN_ROW_HEIGHT,movableColumns: true,
                dataTree:true,dataTreeStartExpanded:false,dataTreeFilter:false,dataTreeElementColumn: "name",
                dataTreeCollapseElement:ReactDOMServer.renderToStaticMarkup(<CollapseTreeIcon/>),
                dataTreeExpandElement:ReactDOMServer.renderToStaticMarkup(<ExpandTreeIcon/>),
                dataTreeBranchElement:ReactDOMServer.renderToStaticMarkup(<BranchTreeIcon/>),
                ajaxURL: QLTY029_PAGED_URL,
                ajaxRequestFunc,
                filterMode: 'remote',
                sortMode: 'remote',
                progressiveLoad: 'scroll',
                progressiveLoadScrollMargin: 80,
                progressiveLoadDelay: 200,
                paginationSize: pageSizePc,
                pagination: false,
                dataLoader: true,
                dataLoaderLoading: t('Common.LoadingEllipsis'),
                dataLoaderError: t('Common.LoadFailed'),
               }}/>
             </div>
            </SplitterPanel>
            </Splitter>
            </div>
            <Dialog header={t('Otk.EditPartnerDocumentation')} visible={visibleRecord} style={{ width: '40vw' }} onHide={() => hideCertRecord()}>
              <form onSubmit={formikUpdate.handleSubmit}>
                  <div>
                    <label
                        htmlFor="certificate_id"
                        className="block text-md font-semibold text-gray-800"
                    >{t('Ui.R67.Dokuemntacia_obch_partnera')}</label>
                    <select 
                    disabled
                    name="certificate_id"
                    onChange={formikUpdate.handleChange} value={formikUpdate.values.certificate_id} 
                    className="bg-white block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40">
                      <option value="">{t('Ui.R67.Vyber_dokumentaciu')}</option>
                      {otkCertificates.map((certificate) => (
                        <option key={certificate.id} value={certificate.id}>{certificate.name}</option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label
                        htmlFor="start_of_validity"
                        className="block text-md font-semibold text-gray-800"
                    >{t('Ui.R67.Datum_platnosti_od')}</label>
                    <input
                        name='start_of_validity'
                        type="date" required
                        onChange={formikUpdate.handleChange} value={formikUpdate.values.start_of_validity}
                        className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                    />
                    </div>
                    <div>
                    <label
                        htmlFor="end_of_validity"
                        className="block text-md font-semibold text-gray-800"
                    >{t('Ui.R67.Datum_platnosti_do')}</label>
                    <input
                        name='end_of_validity'
                        type="date" required
                        onChange={formikUpdate.handleChange} value={formikUpdate.values.end_of_validity}
                        className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                    />
                    </div>
                    <div>
                    <label
                        htmlFor="description"
                        className="block text-md font-semibold text-gray-800"
                    >{t('Common.Note')}</label>
                    <textarea
                        name='description'
                        type="text"
                        onChange={formikUpdate.handleChange} value={formikUpdate.values.description}
                        className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                    >
                    </textarea>
                    </div> 
                      <div>
                      <label
                          htmlFor="files"
                          className="block text-md font-semibold text-gray-800"
                      >
                          PROTOKOL
                      </label>
                      <input
                          name='files' 
                          accept='image/*,application/pdf'
                          ref={updateFileListRef}
                          onChange={handleUpdateFileChange}
                          className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'
                          type='file'
                          multiple="multiple"
                          id='file'/>
                      </div> 
                      {images!=='' && images.map((img) => ( <div key={img.id} className='flex flex-row p-2'>
                          <div onClick={() => openFilePreview({ url: img.url, filename: img.filename })} className="cursor-pointer">
                              {/\.(pdf|png|jpg|jpeg|gif|webp|bmp|svg|img)$/i.test(img.filename || '') ? (
                                  <embed src={img.url+'#view=FitH&scrollbar=0'} width="100px" height="65px" />
                              ) : (
                                  <div className="w-[100px] h-[65px] flex items-center justify-center bg-gray-100 border rounded"><PaperClipIcon /></div>
                              )}
                          </div>
                              <div className='flex flex-col ml-4'>
                              <a style={{color:'blue',cursor:'pointer',marginBottom:'2px'}} onClick={() => openFilePreview({ url: img.url, filename: img.filename })}>{img.filename}</a>
                              <button type="button" className='w-fit flex flex-row px-2 py-1 border rounded-md bg-red-900' onClick={() => deleteFiles(img)} ><DeleteIcon/><span className='text-white ml-1'>{t('Common.Clear')}</span></button>
                              </div>
                          </div>))}
                      <button type="submit" className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25'>{t('Common.Save')}</button>         
                  </form>
              </Dialog>
      <Dialog header={t('Common.SetMask')} visible={maskVisible} style={{ width: '70vw' }} onHide={() => setMaskVisible(false)}>
        <div className="flex flex-col">
        <button type="button" onClick={() => {changeMarkings(!markUnmark);setMarkUnmarked(!markUnmark);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-700 rounded-md hover:bg-zinc-500'>{markUnmark ? t('Common.DeselectAllUpper') : t('Common.SelectAllUpper')}</button>
        {QLTY029_MASK_DIALOG_FIELDS.map(function(field){
          const item = columns.find((c) => c.field === field);
          if (!item) return null;
          return <div
                        key={field}
                        className="flex flex-row border border-black rounded-md p-2 m-1"
                    >
                         <Checkbox onChange={(e) => setMask(item.field,e.checked)} checked={columnsVisible[item.field]}></Checkbox><span className="ml-2">{item.title}</span>
                    </div>
                })} 
            <button onClick={() => {setUserMaskFilter(QLTY029_MASK_PAGE,"set_columns",columnsVisible,null,null);setMaskVisible(false);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>{t('Ui.R67.SaveUpper')}</button>
        </div>
      </Dialog>
        
            </> 
            );
} 
